import { WsApi, SecuredWsApi } from "@/utils/http-client";

export default {
  generatePasswordCreationUrl(payload) {
    return SecuredWsApi.post("/api/paymentflow/v1/guestgenerateregistrationtoken", payload);
  },
  login(payload) {
    return WsApi.post("/account/jwtlogin", payload);
  },
  getTwoFactorSetupCode() {
    return WsApi.post("/account/getgoogle2fasubscribercode");
  },
  getSession(transactionId) {
    return WsApi.post("/account/requestauth", { transactionId: encodeURIComponent(transactionId) });
  },
};
